export const settingsApp = {
  "AccountSettings.MediaRequestsSettings.SaveButton":
    "mediaRequest-save-button",
  "AccountSettings.JobsFeed.EditButton": "jobsFeed-edit-button",
  "AccountSettings.JobsFeed.SaveButton": "jobsFeed-Save-button",
  "AccountSettings.JobsFeed.PlayingAge": "jobsFeed-playingAge",
  "AccountSettings.AgenyNotificationSettings.EditButton":
    "agenyNotification-edit-button",
};
